import './tab-content-about.scss'
import {CourseDetail} from "../../../typings/course";
import {getYoutubeID} from "../../../utils/common";
interface ITabContentAbout{
	course: CourseDetail
}
const TabContentAbout = ({course}: ITabContentAbout) => {
	let youtubeUrl: string | null = null;
	let haveFacilitator = true;
	if(course?.summary_video){
		youtubeUrl = `https://www.youtube.com/embed/${getYoutubeID(course?.summary_video)}`;
	}
	if(course?.facilitator_name || course?.facilitator_img){
		haveFacilitator = true;
	}
	return (
		<>
			<div className={'d-flex flex-column'}>
				{
					haveFacilitator && (
						<>
							<span className="font-extrabold mb-2">Fasilitator</span>
							<div className="flex items-center mb-3 facilitator">
								<img src={course?.facilitator_img ?? 'https://placehold.co/100x100'} />
								<div className="flex flex-col w-3/4">
									<span className="font-extrabold">{ course?.facilitator_name ?? '-' }</span>
									<span className="text-gray-900 text-opacity-75 fs-7">{ course?.facilitator_desc ?? '-' }</span>
								</div>
							</div>
						</>
					)
				}
				<div className="flex flex-col">
					<span className="mb-2 font-extrabold">Tentang</span>
					<p className="text-gray-900 text-opacity-75">{course.description}</p>
					{
						youtubeUrl && (
							<iframe style={{ width: '100%', height: '240px' }}
							        src={youtubeUrl}
							        title="YouTube video player" frameBorder="0"
							        className="mt--20"
							        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
							        allowFullScreen>
							</iframe>
						)
					}
				</div>
				{/*<span className={'mb-2 fs-7 text-muted'}>Lembaga</span>*/}
				{/*<h4 className={'fw-bold'}>{course.organization.name}</h4>*/}
				{/*<p className={'mb-3'}>{course.organization.description}</p>*/}
				{/*<h3 className={'fw-bold'}>Tentang Kursus</h3>*/}
				{/*<p>{course.description}</p>*/}
			</div>
		</>
	)
}
export default TabContentAbout
